import { orderBy, shuffle } from 'lodash';

export type SortProps = 'asc' | 'desc' | 'random';

export type SortableEntity = {
  name: string;
};

export function applySorting<T extends SortableEntity>(
  items: T[],
  sort: SortProps,
) {
  switch (sort) {
    case 'asc':
      return orderBy(items, (item) => item.name.toLowerCase(), 'asc');
    case 'desc':
      return orderBy(items, (item) => item.name.toLowerCase(), 'desc');
    case 'random':
      return shuffle(items);
  }
}
